module.exports = __webpack_public_path__ + "img/acacia_mweya3.3f00d4f9.jpg";